export class PartialReport {
    accountingId: number;
    date: Date;
    payInAmount: number;
    payOutAmount: number;
    cashInAmount: number;
    cashOutAmount: number;
    grossTotal: number;
    netTotal: number;
    serviceCharge: number;
    partnerAccountingCharge: number;
    name: string;
    loan: number;
    deposit: number;
    cashTotal: number;
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/partial-report/partial-report.type.ts